module.exports = __webpack_public_path__ + "img/medilinkGroupZRY_head.5a62b10a.png";